export const SESSION_STATE = Object.freeze({
  ACTIVE: "active",
  INACTIVE: "inactive",
  UNVERIFIABLE: "unverifiable",
});

export function createSessionLifecycle({ verify, onInactive, channelName, throttleMs = 15000 }) {
  let lastCheckedAt = 0;
  let inFlight = null;
  let disposed = false;
  const channel = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(channelName) : null;

  const check = async ({ force = false } = {}) => {
    if (disposed) return SESSION_STATE.UNVERIFIABLE;
    const now = Date.now();
    if (!force && now - lastCheckedAt < throttleMs) return SESSION_STATE.ACTIVE;
    if (inFlight) return inFlight;
    lastCheckedAt = now;
    inFlight = Promise.resolve(verify()).then((state) => {
      if (state === SESSION_STATE.INACTIVE) onInactive?.();
      return state;
    }).finally(() => { inFlight = null; });
    return inFlight;
  };

  const onFocus = () => { if (document.visibilityState === "visible") void check(); };
  const onVisibility = () => { if (document.visibilityState === "visible") void check(); };
  const onStorage = (event) => { if (event.key === `${channelName}:logout` && event.newValue) onInactive?.(); };
  const onMessage = (event) => { if (event?.data?.type === "logout") onInactive?.(); };

  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("storage", onStorage);
  channel?.addEventListener("message", onMessage);

  return {
    check,
    notifyLogout() {
      try { localStorage.setItem(`${channelName}:logout`, String(Date.now())); } catch {}
      channel?.postMessage({ type: "logout", at: Date.now() });
    },
    dispose() {
      disposed = true;
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("storage", onStorage);
      channel?.removeEventListener("message", onMessage);
      channel?.close();
    },
  };
}
